/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Modal, Button } from 'antd';

interface DateChangeModalProps {
  visible: boolean;
  selectedRecord: any | null;
  onCancel: () => void;
  onApply: () => void;
}

export const DateChangeModal: React.FC<DateChangeModalProps> = ({
  visible,
  selectedRecord,
  onCancel,
  onApply,
}) => {
  return (
    <Modal
      title="Xác nhận thay đổi"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy
        </Button>,
        <Button key="apply" type="primary" onClick={onApply}>
          Áp dụng
        </Button>,
      ]}
    >
      {selectedRecord && (
        <div>
          <p>Bạn có muốn áp dụng thay đổi ngày cho công việc:</p>
          <p style={{ fontWeight: 'bold', marginTop: 8 }}>
            {selectedRecord.tenCongViec || selectedRecord.originalData?.congViec?.tenCongViec || ''}
          </p>
          <div style={{ marginTop: 16 }}>
            <p>
              <strong>Ngày bắt đầu:</strong>{' '}
              {selectedRecord.ngayBatDau
                ? typeof selectedRecord.ngayBatDau === 'string'
                  ? selectedRecord.ngayBatDau
                  : new Date(selectedRecord.ngayBatDau).toLocaleDateString('vi-VN')
                : 'Chưa có'}
            </p>
            <p>
              <strong>Ngày kết thúc:</strong>{' '}
              {selectedRecord.ngayKetThuc
                ? typeof selectedRecord.ngayKetThuc === 'string'
                  ? selectedRecord.ngayKetThuc
                  : new Date(selectedRecord.ngayKetThuc).toLocaleDateString('vi-VN')
                : 'Chưa có'}
            </p>
          </div>
        </div>
      )}
    </Modal>
  );
};

